const HE = 'he'
const EN = 'en'

const LANGUAGES = [HE, EN]

const languages = {
    HE,
    EN,
    LANGUAGES,
}

export default languages
